import React, { useEffect, useState } from "react";
import "../header/Header.css";
import DP from "../../assets/profilePlaceholder.jpg";
import { Dropdown } from "react-bootstrap";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { navData } from "../../utils/staticData";
import { handleNavigate } from "../../utils/commonHelper";
import { useSelector } from "react-redux";
import { FiBell } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import { toastMessage } from "../../utils/toastMessage";
import LogoutModal from "../modals/LogoutModal";
import { getToken } from "../../config/AxiosInstance";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { logicalIcon, webLogoWhite } from "../../assets";
import { MdOutlineLogin } from "react-icons/md";
import { socket } from "../../utils/socket";
import Notification from "./Notification";
import { logoutApi } from "../../services/auth";

const Header = () => {
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [logoutModal, setLogoutModal] = useState(false);
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);

  function refreshPage() {
    window.location.reload();
  }

  // Logout Handler
  const logoutHandler = async () => {
    try {
      await logoutApi();
      localStorage.removeItem("logic_chat_token");
      setLogoutModal(false);
      navigate("/");
      toastMessage("Logout Successfully", "success", "Logout");
      socket.disconnect();
    } catch (error) {
      console.log({ error });
      localStorage.removeItem("logic_chat_token");
      setLogoutModal(false);
      navigate("/");
      toastMessage("Logout Successfully", "success", "Logout");
      socket.disconnect();
    }
  };

  useEffect(() => {
    document.body.classList.toggle("mobile_open", mobileMenu);
  }, [mobileMenu]);

  return (
    <>
      <Navbar className="navbar-body header">
        <div className="custom_container">
          <div className="wrap_cstm_header">
            <Navbar.Brand onClick={refreshPage}>
              <Link to="#" id="link">
                <img
                  // src={Logo}
                  // src={logicalIcon}
                  src={webLogoWhite}
                  alt="Logo"
                />
              </Link>
            </Navbar.Brand>

            <Nav className="nav_list">
              <Link to={"/contact-us"}>Contact Us</Link>
              {navData?.map((data, ind) => (
                <Link
                  key={ind}
                  to={data?.path}
                  id={ind}
                  onClick={() => {
                    setMobileMenu(!mobileMenu);
                    handleNavigate("/", data?.id, navigate);
                  }}
                >
                  {data?.name}
                </Link>
              ))}
              {getToken() && <Link to={"/dashboard/profile"}>Dashboard</Link>}
            </Nav>

            <div className="content_right">
              {getToken() ? (
                <div className="content_right">
                  <div className="notification-icon">
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <FiBell />
                      </Dropdown.Toggle>

                      {/* ------------notification-call------------- */}
                      <Notification />
                    </Dropdown>
                  </div>

                  <div className="custom_dropdown profile_dropdown">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <img src={showAuth?.profilePicture || DP} />
                        <IoIosArrowDown />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Link to="/dashboard/profile">
                          <Dropdown.Item as={"span"} className="border_profile">
                            <IoSettingsOutline />
                            <span>Profile Settings</span>
                          </Dropdown.Item>
                        </Link>

                        <Link
                          to="#"
                          onClick={(e) => {
                            setLogoutModal(true);
                            e.preventDefault();
                          }}
                        >
                          <Dropdown.Item as={"span"} className="inside_logout">
                            <MdOutlineLogin className="logout" />
                            <span>Logout</span>
                          </Dropdown.Item>
                        </Link>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              ) : (
                <Link to="/login" className="button nav_btn">
                  {/* <IoLogInOutline/> */}
                  Login
                </Link>
              )}

              <div
                className="hamburger-menu"
                onClick={() => setMobileMenu(!mobileMenu)}
              >
                {mobileMenu ? <FaTimes /> : <GiHamburgerMenu />}
              </div>
            </div>
          </div>
        </div>
      </Navbar>

      <LogoutModal
        show={logoutModal}
        handleClose={() => setLogoutModal(false)}
        action={logoutHandler}
      />
    </>
  );
};

export default Header;
